












































import Vue from 'vue';
import dateFormat from '@/utils/dateFormat';
import { isEqual, assign, isEmpty } from 'lodash';

enum DeleteOptions {
  DELETE_SINGLE_OCCURRENCE = 0,
  DELETE_FUTURE_OCCURRENCES = 1,
  DELETE_ENTIRE_EVENT_SERIES = 2
}

interface RecurrenceSaveOptions {
  recurrence: boolean;
  width: number | string;
}

export default Vue.extend({
  data() {
    return {
      dialog: false,
      title: '(no title)',
      resolve: null as any,
      reject: null as any,
      DeleteOptions,
      label: {
        cancel: 'Cancel',
        ok: 'Ok'
      },
      options: {
        width: 300 as number | string,
        recurrence: false
      } as RecurrenceSaveOptions,

      buttonOptions: {
        text: false,
        left: {
          text: 'Cancel'
        },
        right: {
          color: 'primary',
          text: 'Continue',
          icon: null,
          iconOnly: false
        }
      },
      choice: DeleteOptions.DELETE_SINGLE_OCCURRENCE
    };
  },

  methods: {
    open(title?: string, options?: RecurrenceSaveOptions) {
      this.dialog = true;
      title ? (this.title = title) : this.title;
      if (!isEmpty(options)) {
        console.log('ok not empty', options);
        this.options = Object.assign(this.options, options);
        console.log(assign({ options }, { options: this.options }));
        console.log(assign({ options: this.options }, { options }));

        if (!options!.recurrence) {
          this.label.cancel = 'No';
          this.label.ok = 'Yes';
        }
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
      });
    },
    close() {
      this.title = '';
    },
    agree() {
      this.dialog = false;
      return this.resolve(
        this.options.recurrence
          ? this.choice
          : DeleteOptions.DELETE_ENTIRE_EVENT_SERIES
      );
    },
    cancel() {
      this.dialog = false;
      return this.resolve(null);
    }
  },
  watch: {
    dialog: {
      handler(val) {
        val || this.close();
      }
    }
  },
  beforeDestroy() {
    this.choice = 0;
  }
});
